export const deliveryStatuses = [
  { id: "DRAFT", name: "Projekt" },
  { id: "NEW", name: "Nowy" },
  { id: "APPROACHING_ORIGIN", name: "W drodze do załadunku" },
  { id: "APPROACHING_DESTINATION", name: "W drodze do rozładunku" },
  { id: "IN_DESTINATION", name: "W miejscu docelowym" },
  { id: "CONFIRMED", name: "Potwierdzony" },
  { id: "CANCELLED", name: "Anulowany" },
];

export const deliveryStatusOptions = [
  { value: "DRAFT", label: "Projekt" },
  { value: "NEW", label: "Nowy" },
  { value: "APPROACHING_ORIGIN", label: "W drodze do załadunku" },
  { value: "APPROACHING_DESTINATION", label: "W drodze do rozładunku" },
  { value: "IN_DESTINATION", label: "W miejscu docelowym" },
  { value: "CONFIRMED", label: "Potwierdzony" },
  { value: "CANCELLED", label: "Anulowany" },
];
